import { render, staticRenderFns } from "./CRMRelationshipMappingList.vue?vue&type=template&id=70208e77"
import script from "./CRMRelationshipMappingList.vue?vue&type=script&lang=js"
export * from "./CRMRelationshipMappingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports